import { render } from "./_id.vue?vue&type=template&id=f89e3c24&scoped=true"
import script from "./_id.vue?vue&type=script&lang=js"
export * from "./_id.vue?vue&type=script&lang=js"

import "./_id.vue?vue&type=style&index=0&id=f89e3c24&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f89e3c24"

export default script